import { useState } from "react";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import Typography from "../Typography";

const PasswordInput = ({ register, name, apiErrors, className = "", ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputProps = register ? { ...register(name) } : { name, ...props };

  return (
    <div className="relative">
      <input
        type={showPassword ? "text" : "password"}
        className={`w-full text-sm border border-border-primary rounded-sm px-3 py-1.5 pr-10 text-text-primary bg-surface-primary ${className}`}
        {...inputProps}
        {...props}
      />
      <button
        type="button"
        className="absolute right-0 top-1/2 -translate-y-1/2 pr-2 text-text-secondary hover:text-text-primary bg-transparent border-none p-0 cursor-pointer"
        onClick={() => setShowPassword(!showPassword)}
        aria-label={showPassword ? "Hide password" : "Show password"}
        aria-pressed={showPassword}
      >
        {showPassword ? (
          <RiEyeOffLine className="text-muted" aria-hidden />
        ) : (
          <RiEyeLine className="text-muted" aria-hidden />
        )}
      </button>
      {apiErrors && (
        <Typography variant="text2" className="block w-full mt-1  text-badge-danger">
          {apiErrors}
        </Typography>
      )}
    </div>
  );
};

export default PasswordInput;
